import styled from 'styled-components';

/**
 * A small floating chip showing a video position.
 *
 * Used by transient readouts that hover over the clip-preview control bar — the
 * scrubber hover preview, and the comment-marker drag label. They are the same
 * object visually, so they share one definition rather than drifting apart:
 * a 12px popover chip with tabular numerals, so the digits don't jitter as the
 * time changes under a moving cursor.
 *
 * Non-interactive by design — these track the pointer, so they must never
 * become a hit target themselves.
 */
export const TimecodePill = styled.span`
  display: inline-block;
  padding: 2px 6px;
  border-radius: var(--radius-sm, 4px);
  background: var(--popover);
  border: 1px solid var(--border-subtle);
  box-shadow: var(--elevation-md);
  color: var(--foreground);
  font-size: var(--text-xs, 12px);
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
  white-space: nowrap;
  pointer-events: none;
`;

export default TimecodePill;
